module.exports = __webpack_public_path__ + "static/media/ImagePlaceholder-2.9f4290c8.svg";